import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';

export default class Icon extends React.Component {
    render() {
        var classes = getComponentClasses('icon', this.props.variations);

        return (
            <span className={classes}>
                {this.props.children}
            </span>
        );
    }
}

Icon.propTypes = {
    variations: PropTypes.array
};

Icon.defaultProps = {
    variations: []
}



// WEBPACK FOOTER //
// ./node_modules/@99designs/react-components/components/Icon.jsx